const initialState = {
    content: {},
    
};
const productDetails = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_PRODUCT_DETAILS':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default productDetails;
